import { render, staticRenderFns } from "./courier-detail-modal.vue?vue&type=template&id=6f9970b2&scoped=true&"
import script from "./courier-detail-modal.js?vue&type=script&lang=js&"
export * from "./courier-detail-modal.js?vue&type=script&lang=js&"
import style0 from "./courier-detail-modal.scss?vue&type=style&index=0&id=6f9970b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9970b2",
  null
  
)

export default component.exports